import * as classNames from 'classnames'
import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import ItemCard from '../itemCard'

const GridDefault = ({
  items,
  viewType,
  currentSite,
  itemDecorator,
  isSqueezed,
  videoMuted,
  muteVideo
}: {
  items: any
  viewType: string
  currentSite: string
  itemDecorator: any
  isSqueezed: boolean
  videoMuted?: boolean
  muteVideo?: () => void
}) => {
  const rootClassName = classNames('product-grid', {
    'product-grid--squeezed': isSqueezed
  })

  return (
    <ul data-test-selector="grid-layout" className={rootClassName}>
      {items.map((item: IItem, index: number) => {
        return (
          <li key={item.id}>
            <ItemCard
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
              videoMuted={false}
              muteVideo={() => null}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default GridDefault
